import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'retailer-role',
  templateUrl: './retailer.component.html'
})
export class RetailerRoleComponent {
}

